module.exports = __webpack_public_path__ + "static/img/yj-loading.41568f29.gif";